module.exports = __webpack_public_path__ + "img/pride_logo_mobile.7908acab.png";